<template>
  <div class="schedule">
    <div class="title-invisible">
      <h4 class="title">MATCH SCHEDULE</h4>
    </div>
    <app-show-more :info="info" class="blue" :class="info.class"></app-show-more>
    <div class="match-block">
      <div @click="goTodetail(item)" v-for="item in matches" :key="item.id">
        <app-match-card :item="item" class="match"></app-match-card>
      </div>
    </div>
  </div>
</template>
<script>
const url = process.env.VUE_APP_URL;

import Show_more from "@/components/shared/Show_more";
import Match_card from "@/components/shared/Match_card";
export default {
  data() {
    return {
      info: {
        url: "/schedule",
        class: "rect",
      },
      matches: [],
    };
  },
  methods: {
    goTodetail(item) {
      if (
        event.target.tagName == "svg" ||
        event.target.tagName == "path" ||
        event.target.classList.contains("btn") ||
        event.target.parentElement.classList.contains("btn") ||
        event.target.classList.contains("stadium")
      ) {
        return false;
      } else {
        this.$router.push({
          name: "schedule-result",
          params: { id: item.id },
        });
      }
    },
    setMatch() {
      this.axios
        .get(url + "/matches", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setMatch", payload);
          this.matchI();
        });
    },
    matchI() {
      var mas = this.$store.getters.match;
      var today = new Date();
      today.setHours(today.getHours() - 2);

      var pastDates = [];
      mas.map((x) => {
        if (Date.parse(x.eventDate) < Date.parse(today)) {
          x.time = "past";
          pastDates.push(x);
        }
      });
      pastDates
        .sort(function (a, b) {
          var dateA = new Date(a.eventDate),
            dateB = new Date(b.eventDate);
          return dateA - dateB;
        })
        .reverse();
      var pastDatesNew = pastDates.slice(0, 1);

      var tommorow = new Date();
      tommorow.setHours(today.getHours() - 2);

      var futureDates = [];
      mas.map((x) => {
        if (Date.parse(x.eventDate) > Date.parse(tommorow)) {
          x.time = "future";
          futureDates.push(x);
        }
      });
      futureDates.sort(function (a, b) {
        var dateA = new Date(a.eventDate),
          dateB = new Date(b.eventDate);
        return dateA - dateB;
      });
      var futureDatesNew = futureDates.slice(0, 1);

      var matchMas = pastDatesNew.concat(futureDatesNew);
      this.matches = matchMas;
    },
  },
  mounted() {
    this.setMatch();
  },
  components: {
    "app-show-more": Show_more,
    "app-match-card": Match_card,
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 65%;
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
}
.match-block {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 4.5rem;
  width: 100%;
  .match {
    padding-top: 2.3rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    & > p {
      margin-bottom: 2rem;
    }
    .table {
      padding: 0 2rem;
    }
  }
  @media only screen and (max-width: 768px) {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 2.5rem;
  }
  @media only screen and (max-width: 992px) {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-bottom: 7rem;
  }
  & > div {
    width: 50%;
    cursor: pointer;
    @media only screen and (max-width: 992px) {
      width: calc((100% - 4rem) / 2);
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
    &:first-of-type {
      padding: 0 3rem 0 0;
      @media only screen and (max-width: 1199px) {
        padding: 0 2rem 0 0;
      }
      @media only screen and (max-width: 768px) {
        margin-bottom: 5rem;
        padding: 0;
      }
    }
    &:last-of-type {
      padding: 0 0 0 3rem;
      @media only screen and (max-width: 1199px) {
        padding: 0 0 0 2rem;
      }
      @media only screen and (max-width: 768px) {
        padding: 0;
      }
    }
  }
}
</style>